var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"fill-height":""}},[_c('canvas',{ref:"rendercanvas",staticClass:"renderCanvas",staticStyle:{"height":"100%","width":"100%"},attrs:{"tabindex":"0","id":"rendercanvas"}})])}
var staticRenderFns = []

export { render, staticRenderFns }